import React, {useContext} from 'react';
import RNExitApp from 'react-native-exit-app';

import Text from '../../elements/Text';
import Popup from '../../elements/Popup';
import Button from '../../elements/Button';

import styles from './styles';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import {Platform} from 'react-native';
import Config from 'react-native-config';
import {shopContext} from '../../../contexts/ShopContext';
import {removeAllLocalData} from '../../../utils/HelperMethods';

const AccountStatusModal = ({
  visible,
  setVisible = () => {},
  shouldCloseModal = false,
  navigation,
}) => {
  const {colors} = useTheme();
  const ShopC = useContext(shopContext);

  const onPressClose = async () => {
    await removeAllLocalData(ShopC);
    if (!shouldCloseModal) {
      if (Platform.OS === 'web') {
        setVisible(false);
        navigation('/login', {replace: true});
      } else {
        RNExitApp.exitApp();
      }
    } else {
      shouldCloseModal(false);
    }
  };

  return (
    <Popup
      visible={visible}
      title="Contact Support"
      testID={'AccountStatusModal-Popup-Main'}
      description={
        <>
          Your Diathrive account has been{' '}
          <Text variation="Body1SemiBold" color={colors.textMuted}>
            disabled.
          </Text>{' '}
          This may mean your employer is no longer utilizing the Diathrive
          application. If you believe this is a mistake, or would like access to
          your blood sugar data, please contact support at{' '}
          <Text variation="Body1SemiBold" color={colors.textMuted}>
            {`${Config.DIATHRIVE_SUPPORT_EMAIL}.`}
          </Text>
        </>
      }>
      <Button
        testID={tID('AccountStatusModal-Button-Close')}
        style={styles.button}
        onPress={onPressClose}
        title={'Close'}
      />
    </Popup>
  );
};

export default AccountStatusModal;
